
import { mapGetters } from 'vuex'

export default {
  name: 'PaymentGatewayGridLogos',
  props: {
    // keeping defaults cuz of eslint even though storyblok overrides them with empty string
    desktopIconHeight: {
      type: String,
      default: '20px'
    },
    mobileIconHeight: {
      type: String,
      default: '20px'
    },
    paddingIcon: {
      type: [Number, String],
      default: 1.4
    },
    justifyItems: {
      type: String,
      default: 'center'
    },
    columnsCount: {
      type: String,
      default: '2'
    },
    alignContent: {
      type: String,
      default: 'center'
    }
  },
  computed: {
    ...mapGetters({
      countrySpecificInformation: 'storyblok/getCountrySpecificInformation'
    }),
    gatewayLogos () {
      return this.countrySpecificInformation?.content?.PaymentGridLogos || []
    },
    cssVariables () {
      // keeping fallback values here since storyblok sends empty string if not filled out
      return {
        '--mobile-icon-height': this.mobileIconHeight || '20px',
        '--desktop-icon-height': this.desktopIconHeight || '20px',
        '--padding-icon': this.paddingIcon + 'rem' || '1.4rem',
        '--justify-items': this.justifyItems || 'center',
        '--column-width': this.columnPercent + '%',
        '--align-content': this.alignContent || 'center'
      }
    },
    columnPercent () {
      switch (this.columnsCount) {
        case '3':
          return 33.33
        case '4':
          return 25
        default:
          return 50
      }
    }
  },
  methods: {
    convertToProxy (image) {
      return this.$imgproxy.transform(image, 'rs:fit:1000/g:nowe/q:70')
    }
  }
}
